import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section" data-testid="hero-section">
      <div className="hero-content animate-fadeIn px-6">
        <p className="hero-tagline animate-fadeInUp delay-200">Bespoke Fragrance Solutions</p>
        <h1 className="hero-title animate-fadeInUp delay-300">INTERLUDE</h1>
        <p className="hero-tagline animate-fadeInUp delay-400" style={{ marginBottom: '1.5rem' }}>
          For Hotels · Restaurants · Hospitality
        </p>
        
        <p className="max-w-xl mx-auto text-[#4A4A4A] text-base md:text-lg leading-relaxed mb-10 animate-fadeInUp delay-500">
          Elevate your guest experience with signature scents crafted exclusively for your space.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp delay-600">
          <button
            className="btn-primary inline-flex items-center gap-2"
            data-testid="hero-partnership-btn"
            onClick={() => scrollToSection('partnership')}>
            Partner With Us
            <ArrowRight size={16} />
          </button>
          <button
            className="btn-secondary"
            data-testid="hero-collection-btn"
            onClick={() => scrollToSection('collection')}>
            Explore Fragrances
          </button>
        </div>
      </div>

      <div className="scroll-indicator" data-testid="scroll-indicator">
        <span className="scroll-text">Discover</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default HeroSection;
